"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalIntegration = exports.initialState = exports.CalendarName = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var actions = _interopRequireWildcard(require("./personalIntegration.actions"));

var _personalIntegration2 = require("./personalIntegration.helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CalendarName;
exports.CalendarName = CalendarName;

(function (CalendarName) {
  CalendarName["Google"] = "Google";
  CalendarName["Outlook"] = "Outlook";
})(CalendarName || (exports.CalendarName = CalendarName = {}));

var initialState = {
  isLoading: false,
  isLoaded: false,
  activeIntegration: null,
  errors: false,
  usingDkim: false
};
exports.initialState = initialState;
var personalIntegration = (0, _reduxAct.createReducer)({}, initialState).on(actions.getActiveIntegration, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true,
    isLoaded: false
  });
}).on(actions.getActiveIntegrationSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: true,
    usingDkim: payload.using_dkim,
    activeIntegration: (0, _personalIntegration2.transformActiveService)(payload)
  });
}).on(actions.getActiveIntegrationFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    isLoaded: false,
    error: payload
  });
}).on(actions.disconnectFromIntegration, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}).on(actions.disconnectFromIntegrationSuccess, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    activeIntegration: null
  });
}).on(actions.disconnectFromIntegrationFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    error: payload
  });
}).on(actions.updateIntegration, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}).on(actions.updateIntegrationSuccess, function (state, _ref) {
  var type = _ref.type,
      value = _ref.value;
  // at this point we will always have this value
  if (state.activeIntegration === null) return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    activeIntegration: null
  });
  var key = "use".concat(type.replace(/\w/, function (c) {
    return c.toUpperCase();
  }), "Integration");
  var updatedActiveIntegration = {
    [key]: _objectSpread(_objectSpread({}, (state.activeIntegration || {})[key]), {}, {
      enabled: value
    })
  };
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    activeIntegration: _objectSpread(_objectSpread({}, state.activeIntegration), updatedActiveIntegration)
  });
}).on(actions.updateIntegrationFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    error: payload
  });
});
exports.personalIntegration = personalIntegration;